import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText
} from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import ClientsService from "services/SalesDeveloper/ClientsService";


function ModalForm({ modal, toggle, status, id, setShouldGetData }) {
    const [formData, setFormData] = useState({
        status: ""
    })
    const clientsService = new ClientsService()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setFormData({ ...formData, status })
    }, [status])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const ChangeStatusHandler = (_, values) => {
        setLoading(true)
        clientsService.update(id, formData).then(res => {
            if (res && res.status === SuccessOk) {
                setShouldGetData(true)
                toast.success("Status changed successfully")
                toggle()
            }else {
                setLoading(false)
              }
        })
    }
    return (
        <AvForm
            className='form-horizontal'
            onValidSubmit={(e, v) => {
                handleValidSubmit(e, v)
            }}>
            <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
                <ModalHeader toggle={toggle}>
                    Change Status
                <br />
                    <span className="font-size-14" style={{ opacity: .5, }}>Change Status of the Clients</span>
                </ModalHeader>
                <ModalBody>

                    <Row>
                        <Col className="m-0">
                            <CardText tag='h6' className='fw-bold'>
                                Status
                  </CardText>
                            <AvRadioGroup className="mt-2" name="status" value={formData.status} onChange={handleFieldChange} >
                                <AvRadio label="Wrong number" value="Wrong number" />
                                <AvRadio label="Busy" value="Busy" />
                                <AvRadio label="Unreachable" value="Unreachable" />
                                <AvRadio label="Not interested" value="Not interested" />
                                <AvRadio label="Uncontacted" value="Uncontacted" />
                                <AvRadio label="Interested to buy" value="Interested to buy" />
                                <AvRadio label="Interested to sell" value="Interested to sell" />
                                <AvRadio label="VIP" value="VIP" />
                                <AvRadio label="Deal" value="Deal" />
                                <AvRadio label="Pending" value="Pending" />
                                <AvRadio label="Contracting" value="Contracting" />   
                                <AvRadio label="Complain" value="Complain" />                              
                            </AvRadioGroup>
                        </Col>
                    </Row>
                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-end">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='button'
                        onClick={ChangeStatusHandler}
                        disabled={loading ? true : false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </Modal>
        </AvForm>

    )
}

export default ModalForm